import { ToWords } from 'to-words';

const toWords = new ToWords({
    localeCode: 'en-IN',
    converterOptions: {
        currency: true,
        ignoreDecimal: false,
        ignoreZeroCurrency: false,
        doNotAddOnly: false,
        currencyOptions: { // can be used to override defaults for the selected locale
            name: 'Rupee',
            plural: 'Rupees',
            symbol: '₹',
            fractionalUnit: {
                name: 'Paise',
                plural: 'Paise',
                symbol: '',
            },
        }
    }
});

export const convertToWords = (amount) => {
    try {
        return toWords.convert(amount);
    } catch (e) {
        return '';
    }
};



// ... (existing code)

export const calculateProductTax = (product, sellerGST, buyerGST, gstType) => {
    const isTaxable = gstType === 'Regular GST';
    const rate = parseFloat(product.rate) || 0;
    const quantity = parseFloat(product.quantity) || 0;
    const gstRate = parseFloat(product.gstRate) || 0;

    const basicAmount = rate * quantity;

    if (!isTaxable) {
        return {
            basicAmount,
            cgst: 0,
            sgst: 0,
            igst: 0,
            totalTax: 0,
            totalAmount: basicAmount
        };
    }

    // Extract State Codes
    // If buyer GST is "NOT APPLICABLE", treat as intra-state (CGST/SGST)
    const sellerState = sellerGST ? sellerGST.substring(0, 2) : '';
    const buyerState = (buyerGST && buyerGST !== 'NOT APPLICABLE') ? buyerGST.substring(0, 2) : '';

    const isInterState = sellerState !== buyerState && sellerState && buyerState;

    let cgst = 0, sgst = 0, igst = 0;
    const totalTaxAmount = (basicAmount * gstRate) / 100;

    if (isInterState) {
        igst = totalTaxAmount;
    } else {
        cgst = totalTaxAmount / 2;
        sgst = totalTaxAmount / 2;
    }

    return {
        basicAmount,
        cgst,
        sgst,
        igst,
        totalTax: totalTaxAmount,
        totalAmount: basicAmount + totalTaxAmount
    };
};

export const calculateInvoiceSummary = (products, sellerGST, buyerGST, gstType) => {
    let grandTotal = 0;
    let totalTax = 0;
    let totalTaxable = 0;
    let totalCGST = 0;
    let totalSGST = 0;
    let totalIGST = 0;

    // Use Map to preserve insertion order
    const hsnMap = new Map();

    products.forEach((p, index) => {
        const { basicAmount, totalTax: pTax, totalAmount, cgst, sgst, igst } = calculateProductTax(p, sellerGST, buyerGST, gstType);

        grandTotal += totalAmount;
        totalTax += pTax;
        totalTaxable += basicAmount;
        totalCGST += cgst;
        totalSGST += sgst;
        totalIGST += igst;

        // HSN Summary Aggregation
        const code = p.hsnCode || 'N/A';

        if (!hsnMap.has(code)) {
            hsnMap.set(code, {
                hsnCode: code,
                taxableAmount: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                totalTax: 0,
                gstRate: p.gstRate,
                _order: index // Capture first appearance index
            });
        }

        const existing = hsnMap.get(code);
        existing.taxableAmount += basicAmount;
        existing.cgst += cgst;
        existing.sgst += sgst;
        existing.igst += igst;
        existing.totalTax += pTax;
    });

    return {
        grandTotal,
        totalTax,
        totalTaxable,
        cgst: totalCGST,
        sgst: totalSGST,
        igst: totalIGST,
        hsnSummary: Array.from(hsnMap.values()).sort((a, b) => a._order - b._order)
    };
};
